import styled from 'styled-components/macro';
import { DefaultIcon } from '../../../components/Icon';
import { BlueTextLink } from '../../../components/LinkStyles';

export const RequiresActionDiv = styled.div`
  display: flex;
  padding-bottom: 40px;
  @media screen and (min-width: 375px) {
    padding-bottom: 35px;
  }
  @media screen and (min-width: 1024px) {
    margin-top: 0px;
    /* width: 250px; */
    align-items: center;
  }
  @media screen and (min-width: 1440px) {
    margin-top: 0px;
    /* width: 370px; */
  }
`;
export const CustomDefaultIcon = styled(DefaultIcon)`
  width: 25px;
  height: 25px;
  @media screen and (min-width: 1024px) {
    width: 32px;
    height: 32px;
  }
`;
export const RequiresActionP = styled.p`
  margin-left: 15px;
`;

export const SummaryFooterP = styled.p`
  /* font-size: 1.2rem;
  ${props => props.theme.fontStackHeader};
  font-weight: 600;
  @media screen and (min-width: 1024px) {
    font-size: 1.3rem;
  } */

  /* padding-bottom: 16px; */

  padding-bottom: 30px;
  /* @media screen and (min-width: 768px) {
  } */
  @media screen and (min-width: 1024px) {
    padding-bottom: 35px;
  }
`;

export const CustomBlueTextLink = styled(BlueTextLink)`
  font-size: 1.3rem;
`;

export const DateSpan = styled.span`
  color: ${props => props.theme.blue};
`;
